export const COMMA: string = ','
export const TRUE: string = 'true'
export const FALSE: string = 'false'
export const EMPTY_STRING: string = ''
export const DASH: string = '-'
export const EXCLUDE: string = '!'
export const LOADING_STRING: string = '[Loading...]'
export const DEFAULT_PASSWORD_VALUE: string = '••••••'
export const UNMONITORED_INDICATOR: string = '⦸'
export const COMMON_DEVICES_PARTITION_NAME: string = '[Common Devices Partition]'
